export enum OrderCargoOrderFinishedDownloadRequestOrder {
  START_TIME_ASC = "START_TIME_ASC",
  START_TIME_DESC = "START_TIME_DESC",
  HUMAN_ID_ASC = "HUMAN_ID_ASC",
  HUMAN_ID_DESC = "HUMAN_ID_DESC",
}

export enum OrderCargoOrderFinishedDownloadRequestPublicStatus {
  PRIVATE = "PRIVATE",
  PUBLISHED = "PUBLISHED",
  PUBLIC = "PUBLIC",
}

export type OrderCargoOrderFinishedDownloadRequestQueryParams = {
  isCancelled?: boolean;
  isApproved?: boolean;
  client?: string[];
  dispatch?: string[];
  driver?: string[];
  externalId?: string[];
  address?: string[];
  startAddress?: string[];
  midAddress?: string[];
  endAddress?: string[];
  taxi?: string[];
  passenger?: string[];
  publicStatus?: OrderCargoOrderFinishedDownloadRequestPublicStatus;
  order?: OrderCargoOrderFinishedDownloadRequestOrder;
  startTimeSince?: Date;
  startTimeTo?: Date;
  humanId?: number[];
};

type OrderCargoOrderFinishedDownloadRequest = {
  internalOrderId?: number[];
  isCancelled?: boolean;
  isApproved?: boolean;
  startTimeSince?: Date;
  startTimeTo?: Date;
  client?: string[];
  dispatch?: string[];
  driver?: string[];
  externalId?: string[];
  address?: string[];
  startAddress?: string[];
  midAddress?: string[];
  endAddress?: string[];
  taxi?: string[];
  passenger?: string[];
  publicStatus?: OrderCargoOrderFinishedDownloadRequestPublicStatus;
  order?: OrderCargoOrderFinishedDownloadRequestOrder;
};

export default OrderCargoOrderFinishedDownloadRequest;
